export const getIsScrollbarVisible = (
  scrollWrapperHeight = 0,
  childHeight = 0
) => scrollWrapperHeight < childHeight
